import styled from 'styled-components';
import { fontSizes } from 'syf-component-library/defaultTheme';
import Button from 'syf-component-library/ui/atoms/Button';
import SimpleModalPortal from 'syf-component-library/ui/patterns/SimpleModalPortal';
import Body from 'syf-component-library/ui/typography/Body';
import query from 'syf-component-library/const/mediaQueries';
export const CrossBorderButton = styled(Button) `
  width: 100%;
`;
export const ButtonContainer = styled.div `
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  ${CrossBorderButton}:first-child {
    margin-bottom: 0;
  }
  ${CrossBorderButton}:last-child {
    margin-top: 0;
  }
`;
export const Content = styled(Body) `
  text-align: center;
`;
export const Title = styled(Body) `
  text-align: center;
  font-weight: bold;
  font-size: ${fontSizes.medium}px;
`;
export const ModalContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const CrossBorderSimpleModal = styled(SimpleModalPortal) `
  width: 327px;
  // setting the modal to be centered in the slide in modal portal
  position: absolute;
  // this overrides the default translation of (-50%, -25%) for mobile
  transform: translate(-50%, -10%) !important;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${query.greaterThanMedium} {
    & {
      // rule for overriding the min-width on the CL component
      min-width: 327px;
      // rule for overriding the transform css for desktop
      transform: translate(-50%, 3%) !important;
    }
  }
`;
